<ng-select [items]="items"
           bindValue="id"
           [placeholder]="'contract-search.name' | transloco"
           [typeToSearchText]="'contract-search.startSearch' | transloco"
           [notFoundText]="'contract-search.noFind' | transloco"
           [loadingText]="'contract-search.loaderSearch' | transloco"
           [compareWith]="compareFn"
           [multiple]="false"
           [hideSelected]="true"
           [trackByFn]="trackByFn"
           [loading]="itemLoading"
           [typeahead]="itemInput$"
           (change)="onModelChanged($event)"
           [(ngModel)]="model"
           [searchable]="true"
           [clearable]="true">
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <span class="ng-value-label">{{item.title}} №{{item.number}} {{ 'contract-search.from' | transloco }} {{item.date | date:'dd.MM.yyyy'}}</span>
    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    {{item.title}} №{{item.number}} {{ 'contract-search.from' | transloco }} {{item.date | date:'dd.MM.yyyy'}}
  </ng-template>
</ng-select>
